import { render } from "./One2.vue?vue&type=template&id=1e858af0&scoped=true&lang=pug"
import script from "./One2.vue?vue&type=script&lang=js"
export * from "./One2.vue?vue&type=script&lang=js"

import "./One2.vue?vue&type=style&index=0&id=1e858af0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e858af0"]])

export default __exports__